<template>
  <div style="overflow-x: hidden">
    <div class="invisibleStep pa-2 fill-height step2 " style="overflow: hidden">
      <div class="fill-height introStep introStep1" v-show="introSlider === 1">
        <div class="fill-height text-center">
          <img src="../../assets/image/user-journey/slide3.svg" alt="">
          <div class="titleStep">
            در مسیر ساختن حال خوب همراه شما هستیم
          </div>
          <div class="contentStep">
            برای پیشنهاد دقیق‌ترین تراپیست از بین بهترین درمانگران، لازم است به چند سوال کوتاه پاسخ دهید تا نیازها و
            شرایط شما را بشناسیم.
          </div>
          <div class="actionStep">
            <v-btn class="nextBtn" @click="nextIntroStep" color="#30A778" block id="confirm_btn" elevation="0">
              بعدی
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div class="matchArea" :class="{ 'matchArea--loading': questionLoading }">
      <div v-if="questionLoading" class="question-local-loader">
        <v-progress-circular indeterminate color="#30A778" size="44" width="3"/>
      </div>
      <v-fade-transition>
        <div class="generalHint mt-10" v-if="showHintMessages">
          {{ $t('matchMaking.hintTitle') }}
          <br>
          {{ $t('matchMaking.hintDescription[0]') }}
          <br>
          {{ $t('matchMaking.hintDescription[1]') }}
        </div>
      </v-fade-transition>


      <div class="invisibleStep " :style="showHintMessages && 'font-size: 18px;font-weight:bolder'"
           :class="`step${this.currentStep}`" v-if="currentStep > 6 && (questionLoading || questionRender != null)">
        <template v-if="questionRender">
          <div class="titleQuestionItem">
            <template v-if="questionRender.answer_record">
              <template v-if="$vuetify.rtl">
                {{ questionRender.answer_record.question.q_text }}
              </template>
              <template v-else>
                {{ questionRender.answer_record.question.q_en_text }}
              </template>
            </template>
          </div>
          <v-form ref="matchMaking" class="mt-5" v-if="questionRender.answer_record">
            <option-handler-match-making
                :key="questionRender.answer_record.id"
                :call-change-in-option="callChangeInOption"
                :options="questionRender.answer_record"
                :type="questionRender.answer_record.question.vue_type"
                @prepareData="prepareData"
            />
          </v-form>
        </template>
      </div>
      <div class="actionMobile" v-if="currentStep >= 7 && questionRender && $vuetify.breakpoint.mdAndDown">
        <div class="doneBtn">
          <v-btn class="nextBtn" color="#3CBE8B" block id="confirm_btn" elevation="0"
                 :disabled="questionLoading" :loading="questionLoading"
                 @click="callOptionChanges">
            {{ $t('matchMaking.buttons.submit') }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
// import {ajaxGet, ajaxPost} from "@/utilities";
import {EventBus} from "@/event-bus";
import gsap from "gsap";
import OptionHandlerMatchMaking from "@/components/MatchMaking/OptionHandlerMatchMaking";

export default {
  components: {OptionHandlerMatchMaking},
  props: {
    language: {
      default: 'fa'
    },
    next: Boolean,
    initialAnswerRecord: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      introSlider: 1,
      // Used when landing with ?flow=individual|couple|child
      psychology_fields: {
        individual: '1',
        couple: 2,
        child: 4
      },
      callChangeInOption: false,
      showHintMessages: false,
      questionRender: null,
      psychologyFieldsSelected: null,
      currentStep: 1,
      payloadBody: null,
      user_m_test_id: null,
      seekbar: 0,
      questionLoading: false,
      skipHistoryPush: false,
    }
  },
  methods: {
    setQuestionLoading(val) {
      this.questionLoading = val
    },
    pushMatchMakingHistory() {
      if (this.skipHistoryPush) {
        return
      }
      const historyState = {journeyStep: 'matchMaking'}
      const step2Visible = document.querySelector('.step2')
          && getComputedStyle(document.querySelector('.step2')).display !== 'none'

      if (step2Visible) {
        historyState.mmStep = 'intro'
        historyState.introSlider = this.introSlider
      } else if (this.currentStep >= 7) {
        historyState.mmStep = 'question'
        historyState.questionStackId = this.questionRender?.answer_record?.id
      }

      window.history.pushState(historyState, '', '?step=matchmaking')
    },
    backInMatchMaking() {
      // Only handle intro slider back
      const step2Visible = getComputedStyle(document.querySelector('.step2')).display !== 'none';
      if (step2Visible) {
        // Inside intro: go to previous slide if possible
        if (this.introSlider > 1) {
          const current = `.introStep${this.introSlider}`;
          const prevIndex = this.introSlider - 1;
          const prev = `.introStep${prevIndex}`;
          this.seekbar = this.seekbar - 5
          this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)
          gsap.to(current, {
            x: 50, opacity: 0, display: 'none', onComplete: () => {
              this.introSlider = prevIndex;
              this.$nextTick(() => {
                gsap.fromTo(prev, {x: -50, opacity: 0, display: 'none'}, {x: 0, opacity: 1, display: 'block'});
              })
            }
          });
        }
        return;
      }
      if (!step2Visible && this.currentStep >= 7 && this.questionRender?.answer_record) {
        this.prevQuestion()
        return
      }
    },
    nextIntroStep() {

      this.$emitEvent('removeMatchMakingFromHeaderIncludes')
      this.seekbar = this.seekbar + 5
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)

      gsap.to('.step2', {
        x: -50, opacity: 0, display: 'none', onComplete: () => {
          // Skip field + gender screens; jump straight into API quiz
          this.currentStep = 6
          this.startQuiz()
        }
      })

    },
    resolvePsychologyFieldId() {
      const fromFlow = this.$route.query.flow && this.psychology_fields[this.$route.query.flow]
      const stored = localStorage.getItem('psychology_field_id')
      const raw = stored || fromFlow || '1'
      return Number(raw) || 1
    },
    startQuiz() {
      this.psychologyFieldsSelected = this.resolvePsychologyFieldId()
      localStorage.setItem('psychology_field_id', this.psychologyFieldsSelected)
      localStorage.removeItem('matchmaking_gender')

      const token = localStorage.getItem('set_session_token')
      const begin = () => this.getQuestions()
      if (token && token !== 'undefined') {
        this.requesting('match_making', 'updatePsychologyFiled', '', {
          token,
          psychology_field_id: this.psychologyFieldsSelected
        }).then(begin).catch(begin)
      } else {
        begin()
      }
    },
    callOptionChanges() {
      this.callChangeInOption = true
      this.$nextTick().then(() => {
        this.callChangeInOption = false
      })

    },
    checkUserHasPendingTest() {
      if (this.$store.getters.userIsLoggedIn || localStorage.getItem('user_token_matchMaking') != 'undefined') {
        this.$emitEvent('setLoading', true)
        this.requesting('match_making', 'initTest', '', '', {
          'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking'),
        }).then((resp) => {
          if (resp.status_code == 404) {
            localStorage.setItem('user_token_matchMaking', null)
            this.startQuiz()
          } else {
            this.getQuestions();
          }
        }).finally(() => {
          this.$emitEvent('setLoading', false)
        })
      }
    },
    getQuestions() {
      this.showHintMessages = false
      this.setQuestionLoading(true)
      let urlName = 'initTestWithOutCheck'
      let param = {}
      let header = {
        'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
      }
      if (this.psychologyFieldsSelected != null) {
        urlName = 'initTestWithPsychology'
        param = {
          psychology_field_id: this.psychologyFieldsSelected
        }
        header = {}
      }
      this.requesting('match_making', urlName, param, {}, header).then((resp) => {
        if (resp.status_code == 206) {
          this.$emit('matchMakingTestEnd', this.buildMatchAdditionalData())
        } else {
          localStorage.setItem('user_token_matchMaking', resp.data.token)
          this.user_m_test_id = resp.data.answer_record.user_m_test_id
          this.$emitEvent('removeMatchMakingFromHeaderIncludes')
          this.questionRender = resp.data
          this.revealQuizStep()
          this.$nextTick(() => {
            this.pushMatchMakingHistory()
          })
        }
      }).finally(() => {
        this.setQuestionLoading(false)
      })
    },
    submitAnswer() {
      this.$emitEvent('setStepValue', {
        key: 'temp',
        value: null,
        nextStep: false
      })
      this.seekbar = this.seekbar + 6
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)
      if (Object.keys(this.payloadBody).length === 0 || this.payloadBody.answers.length === 0 || this.payloadBody.answers[0] == undefined) {
        this.$emitEvent('setStepValue', {
          key: 'temp',
          value: null,
          nextStep: false
        })
        this.$emitEvent("notify", {
          title: this.$t('matchMaking.pleaseAnswer'),
          color: "red",
        });
        return;
      }
      this.setQuestionLoading(true)
      const answerRecord = this.questionRender && this.questionRender.answer_record
      const answersSnapshot = (this.payloadBody.answers || []).slice()
      const shouldSyncMajorField = this.isMajorFieldQuestion(answerRecord)

      this.toInVisible(() => {
        if (answerRecord && answerRecord.question_id == 1) {
          this.storeFirstQuestionOption()
        }

        const continueSubmit = () => {
          this.questionRender = null
          this.showHintMessages = false
          this.payloadBody.token = localStorage.getItem('set_session_token');
          this.requesting('match_making', 'submitAnswer', '', this.payloadBody, {}).then((resp) => {
            if (resp.status_code == 206) {
              this.$emit('matchMakingTestEnd', this.buildMatchAdditionalData())
            } else {
              this.user_m_test_id = resp.data.answer_record.user_m_test_id
              this.nextStep();
              this.questionRender = resp.data
              this.$nextTick(() => {
                this.pushMatchMakingHistory()
              })
            }
          }).finally(() => {
            this.setQuestionLoading(false)
            this.payloadBody = {}
          }).catch((error) => {
            this.setQuestionLoading(false)
            if (error.response && error.response.status == 400) {
              this.$emit('restartTest')
            }
          })
        }

        if (shouldSyncMajorField) {
          this.syncMajorFieldFromFirstQuestion(answerRecord, answersSnapshot)
              .finally(continueSubmit)
        } else {
          continueSubmit()
        }
      })
    },
    isMajorFieldQuestion(answerRecord) {
      if (!answerRecord || !answerRecord.question) {
        return false
      }
      if (Number(answerRecord.question_id) === 1) {
        return true
      }
      const qText = `${answerRecord.question.q_text || ''} ${answerRecord.question.q_en_text || ''}`
      return /حوزه|موضوع مشاوره|need help|therapy topic|psychology field/i.test(qText)
    },
    mapOptionToPsychologyFieldId(option) {
      const t = `${(option && option.text) || ''} ${(option && option.en_text) || ''}`.toLowerCase()
      if (/کودک|نوجوان|child|teen|kid/.test(t)) {
        return 4
      }
      if (/زوج|ازدواج|couple|marri|خانواده|family/.test(t)) {
        return 2
      }
      if (/فردی|individual|بالغ|۱۸|18\+|adult/.test(t)) {
        return 1
      }
      return null
    },
    resolvePsychologyFieldIdFromAnswers(answerRecord, answers) {
      const options = (answerRecord && answerRecord.question && answerRecord.question.question_options) || []
      const selectedId = answers && answers[0] && answers[0].question_option_id
      if (selectedId == null) {
        return null
      }

      const selectedOption = options.find((o) => o.id == selectedId)
      const mapped = this.mapOptionToPsychologyFieldId(selectedOption)
      if (mapped) {
        return mapped
      }

      // Fallback: classic 3-option order → individual / couple / child
      const idx = options.findIndex((o) => o.id == selectedId)
      if (idx === 0) return 1
      if (idx === 1) return 2
      if (idx === 2) return 4
      return null
    },
    syncMajorFieldFromFirstQuestion(answerRecord, answers) {
      const fieldId = this.resolvePsychologyFieldIdFromAnswers(answerRecord, answers)
      if (!fieldId) {
        return Promise.resolve()
      }

      this.psychologyFieldsSelected = fieldId
      localStorage.setItem('psychology_field_id', fieldId)

      const token = localStorage.getItem('set_session_token')
      if (!token || token === 'undefined') {
        return Promise.resolve()
      }

      return this.requesting('match_making', 'updatePsychologyFiled', '', {
        token,
        psychology_field_id: fieldId,
      }).catch(() => null)
    },
    storeFirstQuestionOption() {
      localStorage.setItem('firstQuestionMatchMaking', this.payloadBody.answers[0].question_option_id)
    },
    prepareData(val) {
      this.payloadBody = val
      EventBus.$emit('setStepValue', {
        key: 'temp',
        value: this.payloadBody,
      })
      this.submitAnswer()
    },
    prevQuestion() {
      const answerRecord = this.questionRender?.answer_record
      const userMTestId = this.user_m_test_id || answerRecord?.user_m_test_id
      const questionStackId = answerRecord?.id
      if (!userMTestId || !questionStackId || this.questionLoading) {
        return
      }

      const previousQuestion = this.questionRender
      this.setQuestionLoading(true)
      this.toInVisible(() => {
        this.questionRender = null
        this.showHintMessages = false
        this.requesting('match_making', 'prevQuestion', '', {
          test_id: 2,
          user_m_test_id: userMTestId,
          question_stack_id: questionStackId,
        }, {}).then((resp) => {
          if (resp.data?.answer_record) {
            this.seekbar = Math.max(0, this.seekbar - 6)
            this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)
            this.user_m_test_id = resp.data.answer_record.user_m_test_id
            this.questionRender = resp.data
            this.$nextTick(() => {
              gsap.fromTo(`.step${this.currentStep}`, {x: -50, opacity: 0, display: 'none'}, {
                x: 0,
                opacity: 1,
                display: 'block',
              })
            })
          } else {
            this.goBackToIntro()
          }
        }).finally(() => {
          this.setQuestionLoading(false)
        }).catch(() => {
          this.setQuestionLoading(false)
          this.questionRender = previousQuestion
          this.showQuestionStep()
        })
      })
    },
    goBackToIntro() {
      this.questionRender = null
      this.currentStep = 2
      this.introSlider = 1
      this.seekbar = Math.max(0, this.seekbar - 5)
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', this.seekbar)
      this.$emitEvent('addMatchMakingToHeaderIncludes')
      this.$nextTick(() => {
        gsap.fromTo('.step2', {x: -50, opacity: 0, display: 'none'}, {
          x: 0,
          opacity: 1,
          display: 'block',
        })
        this.pushMatchMakingHistory()
      })
    },
    showQuestionStep() {
      this.$nextTick(() => {
        const el = document.querySelector(`.step${this.currentStep}`)
        if (!el) {
          return
        }
        gsap.fromTo(el, {x: 50, opacity: 0, display: 'none'}, {
          x: 0,
          opacity: 1,
          display: 'block',
          duration: 0.5,
        })
      })
    },
    /** Mount quiz panel at step 7+ then animate it in (avoids GSAP targeting a missing node). */
    revealQuizStep() {
      this.currentStep = Math.max(this.currentStep, 7)
      this.$nextTick(() => {
        const el = document.querySelector(`.step${this.currentStep}`)
        if (!el) {
          return
        }
        gsap.fromTo(el, {x: 50, opacity: 0, display: 'none'}, {
          x: 0,
          opacity: 1,
          display: 'block',
          duration: 0.5,
        })
      })
    },
    getResult() {
      this.$emitEvent('setLoading', true)
      this.requesting('match_making', 'getTestResult', '', {
        'user_m_test_id': this.user_m_test_id,
      }, {}).then((resp) => {
        this.$emit('matchMakingTestEnd', this.buildMatchAdditionalData())
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    loadingHandler(val) {
      this.$nextTick().then(() => {
        this.loading = val
      })
    },
    nextStep() {
      const prevStep = this.currentStep
      const prevEl = document.querySelector(`.step${prevStep}`)
      const advance = () => {
        this.currentStep = Math.max(prevStep + 1, 7)
        this.$nextTick(() => {
          const el = document.querySelector(`.step${this.currentStep}`)
          if (!el) {
            return
          }
          gsap.fromTo(el, {x: 50, opacity: 0, display: 'none'}, {
            x: 0,
            opacity: 1,
            display: 'block',
            duration: 0.5,
          })
        })
      }
      if (prevEl) {
        gsap.to(prevEl, {x: -50, opacity: 0, display: 'none', duration: 0.5}).then(advance)
      } else {
        advance()
      }
    },
    toInVisible(callBack = function () {
    }) {
      const el = document.querySelector(`.step${this.currentStep}`)
      if (!el) {
        callBack()
        return
      }
      gsap.to(el, {x: -50, opacity: 0, display: 'none', duration: 0.5}).then(() => {
        callBack();
      })
    },
    toVisible() {
      setTimeout(() => {
        this.revealQuizStep()
        this.$nextTick(() => {
          this.pushMatchMakingHistory()
        })
      }, 500)
    },
    buildMatchAdditionalData() {
      return {}
    },
  },
  computed: {
    btnMethod() {

    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL
    }
  },
  watch: {
    introSlider(val) {
      if (val > 1) {
        this.$emitEvent('removeMatchMakingFromHeaderIncludes')
      } else {
        this.$emitEvent('addMatchMakingToHeaderIncludes')

      }
    },
    next(val) {
      if (val) {
        this.submitAnswer()
      }
    },
    initialAnswerRecord: {
      handler(val) {
        if (val) {
          this.user_m_test_id = val.user_m_test_id
          this.questionRender = {answer_record: val}
          this.$emitEvent('removeMatchMakingFromHeaderIncludes')
          this.$nextTick().then(() => {
            this.toVisible()
            this.$nextTick(() => {
              this.pushMatchMakingHistory()
            })
          })
        }
      },
      immediate: false
    }

  },
  mounted() {
    this.$onEvent('backInMatchMaking', this.backInMatchMaking)
    window.history.replaceState({
      journeyStep: 'matchMaking',
      mmStep: 'intro',
      introSlider: 1,
    }, '', '?step=matchmaking')
    if (this.initialAnswerRecord) {
      this.user_m_test_id = this.initialAnswerRecord.user_m_test_id
      this.questionRender = {answer_record: this.initialAnswerRecord}
      this.$emitEvent('removeMatchMakingFromHeaderIncludes')
      this.$nextTick().then(() => {
        this.toVisible()
      })
    } else {
      this.$nextTick(() => {
        const intro = document.querySelector('.step2')
        if (intro) {
          gsap.set(intro, {display: 'block', opacity: 1, x: 0})
        }
      })
    }
    if (this.$route.query.flow) {
      this.requesting('match_making', 'updatePsychologyFiled', '', {
        'token': localStorage.getItem('set_session_token'),
        'psychology_field_id': this.psychology_fields[this.$route.query.flow]
      }, {}).then(() => {
        localStorage.setItem('psychology_field_id', this.psychology_fields[this.$route.query.flow])
      })
    }
  }
}
</script>

<style scoped>

@media screen and (max-width: 967px ) {
  .step2 {
    width: 100%;
    overflow-x: hidden;
  }

  .introStep {
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    overflow-x: hidden;
  }

  .introStep img {
    margin-top: 50px;
    width: 80%;
    max-width: 100%;
    height: auto;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }


  .actionStep {
  }


  .stepper-shell {
    max-width: 95% !important;
  }

  .matchArea {
    margin: 0px auto;
    background: white;
    padding: 20px 20px 80px 20px;
    height: 100%;
  }

  .optionItem {
    min-height: 80px !important;
    margin-bottom: 10px !important;
    font-size: 15px !important;

  }

  .titleQuestionItem {
    font-size: 20px !important;
    margin-top: 20px;
  }

  .nextQuestion {

  }

  .actionMobile {
    padding: 16px 20px 15px 20px;
    position: fixed;
    right: 0px !important;
    width: 100% !important;
    left: 0px;
    bottom: 0px;
    background: white;
    box-shadow: 0 -2px 4px 0 rgba(219, 228, 237, 0.40);
    border-radius: 0px !important;
  }

  .prevBtn {
    height: 50px !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    border-radius: 8px !important;
  }

  .nextBtn {
    border-radius: 8px !important;
    margin-top: 0px !important;
  }
}


.actionStep {
  width: 100%;
  margin-top: 30px;
}

.titleStep {
  margin-top: 20px;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
}

.contentStep {
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
}

.nextBtn {
  width: 268px;
  height: 50px !important;
  color: white !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  border-radius: 8px;
  margin-top: 30px;
}

.doneBtn {
  border-radius: 8px !important;
}

.questionActions--desktop {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.questionActions--desktop .prevBtn {
  min-width: 268px;
  height: 50px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  border-radius: 8px !important;
}

.generalHint {
  line-height: 25pt;
  font-size: 15px;
}

.selectableItem {
  height: 100%;
  width: 100%;
  font-size: 10pt;
  border-radius: 10px;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  background: url("../../assets/matchMaking/backitem.png") no-repeat;
  background-size: cover;
  border: solid 2px #d1dcff;
  position: relative;
  margin: auto;

}


.v-stepper {
  box-shadow: none !important;
}

.matchArea {
  overflow-x: hidden;
  width: 100%;
  position: relative;
}

.matchArea--loading > *:not(.question-local-loader) {
  pointer-events: none;
  opacity: 0.45;
}

.question-local-loader {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.88);
  min-height: 160px;
}

.main-container-c {
  font-size: 24px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 100% !important;
  flex-direction: column;
  z-index: 3 !important;
  transition: all .3s linear;
}

.main-background {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #f9ffff !important;
  z-index: 1;
}

.bg-circles {
  position: absolute;
  z-index: 2;
  filter: blur(46px);
  -webkit-filter: blur(46px);
}

.bg-circles.aqua-circle {
  top: -10%;
  left: -5%;
  width: 30%;
}

.bg-circles.green-circle {
  bottom: 12%;
  right: -10%;
  width: 20%;
}

.bg-circles.purple-circle {
  bottom: -15%;
  left: -5%;
  width: 20%;
}

.flex-navigation {
  width: 100%;
  z-index: 10;
  align-self: flex-start;
}

.stepper-shell {
  /*width: 60%;*/
  height: 80%;
  max-height: 700px;
  box-shadow: 0 3px 25px 0 rgba(0, 0, 0, 0.06);
  background-color: #fff;
  border-radius: 20px;
}


.stepper {
  height: 100%;
  margin: 10px 10px 0 10px;
  position: relative;
  border-radius: 20px;
  overflow-x: hidden !important;
}

.invisibleStep {
  opacity: 0;
  display: none;
}


.stepper-item-colored {
  background-color: #f5faff;
}

.selectableItem {
  font-size: 12pt;
  border: 1px solid #ededed;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.3s;

}

.selectableItemActive {
  border: 3px solid #4576d8;
}

.optionItem:hover {
  //transition: all 0.3s;
  border-color: #30a878 !important;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.activeOption {
  border: 2px solid #30a878;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.actionArea {
  position: absolute;
  bottom: 40px;
  right: 10px;
  left: 10px;
  text-align: center;
}

.start-btn {
  height: 35px !important;
  color: #3CBE8B;
  border-radius: 10px;
  transition: background-color .3s linear;
  font-weight: bolder;
  font-size: 15pt;
}

.start-btn:hover {
  background-color: #daf5eb;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.3s;
  transform: translateY(0);
  opacity: 1;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(10px);
}

.titleQuestionItem {
  color: #212121;
  text-align: center;
  /* Title/Large/Bold24 */
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.descQuestionItem {
  color: #212121;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 10px;
}

.greenBox {
  color: #30A778;
  text-align: right;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  border-radius: 8px;
  border: 1px solid #39C990;
  background: rgba(215, 244, 233, 0.50);
  border-radius: 8px;
  padding: 14px 16px;

}

.nextQuestion {
  border-radius: 8px;
  background: #39C990 !important;
  color: white;
  height: 48px !important;
  font-weight: 700;
  font-size: 16px;
}

.optionItem {
  display: flex;
  height: 60px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid #E1E1E1;
  background: #FFF;
  //transition: all 0.3s;
  cursor: pointer;
  margin-bottom: 13px;
}

.activeOption {
  border: 2px solid #39C990;
  //background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
}

.titleQuestionItem {
  color: #212121;
  text-align: center;
  /* Title/Large/Bold24 */
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.radioItem {
  font-size: 14px;
  transition: all 0.3s;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid #E1E1E1;
  background: #FFF;
  transition: all 0.3s;
  cursor: pointer;
}
</style>